import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabDates from '../../form-fields/tab-dates/tab-dates';
class EditViewPostDischargeTabDates extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabDates 
          {...this.props} 
          locked={this.props.locked} 
          referraloutcome={this.props.referraloutcome} 
          
          clientdischargestatus={this.props.clientdischargestatus} 

          postdischargeattemptedcontact90desults={this.props.postdischargeattemptedcontact90desults} 
          postdischargeattemptedcontact180dresults={this.props.postdischargeattemptedcontact180dresults} 
          postdischargeattemptedcontact12mresults={this.props.postdischargeattemptedcontact12mresults} 
          postdischargeattemptedcontact24mresults={this.props.postdischargeattemptedcontact24mresults} 
          postdischargeattemptedcontact36mresults={this.props.postdischargeattemptedcontact36mresults} 
        />
      </div>
    );
  }
}
EditViewPostDischargeTabDates.propTypes = {
  locked: PropTypes.bool,
}
EditViewPostDischargeTabDates = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabDates);
export default EditViewPostDischargeTabDates;